import { NgModule } from '@angular/core';
import {AddItemTabDirective} from "./add-item-tab/add-item-tab.directive";
import {AddItemFormComponent} from "./add-item-form/add-item-form.component";
import { MatButtonModule } from '@angular/material/button';
import {I360TranslateModule} from "../translate/translate.module";
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        I360TranslateModule,
    ],
    declarations: [
        AddItemTabDirective,
        AddItemFormComponent,
    ],
    exports: [
        AddItemTabDirective,
        AddItemFormComponent,
    ],
})
export class I360AddItemModule {}
